import { AcceptUser } from '@/components';
import StudentHistory from '@/components/student-history';
import { useMeeting } from '@/context/meeting-context';

const InstantMeetingsFoundState = () => {
	const { socketData } = useMeeting();
	const { handleMatch, connectionData } = socketData;

	return (
		<div className={'coach-instant-meetings-container'}>
			<div className={'instant-meetings-info-container'}>
				<h1 className={'success-text'}>Hazırsan Öğrenciler Seni Bekliyor</h1>
				<p>Kısa bir süre sonra görüşmeniz başlayacak! Bu süre sarfında öğrencinizi detaylıca inceleyebilir, görüşme öncesi fikir edinebilirsiniz.</p>
			</div>

			<div className={'instant-meetings-actions-container'}>
				<AcceptUser />
			</div>
			<StudentHistory
				studentId={handleMatch?.studentId || connectionData?.userInfos?.studentId}
				gradeId={handleMatch?.gradeId || connectionData?.userInfos?.gradeId}
			/>
		</div>
	);
};

export default InstantMeetingsFoundState;
